/* @flow */
import React from 'react';
import type { Node } from 'react';
import { Icon, IconWrapper } from './styles';
import { LensIcon, PercentIcon, SquareCalcIcon, SquareCheckIcon } from '../Icons';

const CallbackIcons = (): Node => (
	<IconWrapper>
		<Icon>
			<div>
				<svg viewBox="0 0 36 37">{PercentIcon}</svg>
			</div>
			<figcaption>Ипотека</figcaption>
		</Icon>
		<Icon>
			<div>
				<svg viewBox="0 0 36 37">{SquareCalcIcon}</svg>
			</div>
			<figcaption>Оценка</figcaption>
		</Icon>
		<Icon>
			<div>
				<svg viewBox="0 0 37 37">{LensIcon}</svg>
			</div>
			<figcaption>Проверка</figcaption>
		</Icon>
		<Icon>
			<div>
				<svg viewBox="0 0 36 37">{SquareCheckIcon}</svg>
			</div>
			<figcaption>Сделка</figcaption>
		</Icon>
	</IconWrapper>
);

export default CallbackIcons;
